import React, {useEffect} from 'react'
import {useQuery} from '@tanstack/react-query'
import {createSearchParams, useNavigate} from 'react-router-dom'
import {AxiosError} from "axios";
import { createBrowserHistory} from 'history'
import StorageUtil from "@/common/StorageUtil";
import {ACCESS_TOKEN, LOGIN_TYPE, USER_ID, TEAM_ID} from '@/common/Constant'
import UserService, {SvcUser} from "@/service/UserService";
import StringUtil from "@/common/StringUtil";
import Splash from "@/view/layout/Splash";

type LogoutMsg = {
    type : string
}

const AuthenticationView = () => {
    const navigate = useNavigate()
    const history = createBrowserHistory();
    const location = history.location
    const state = location.state as LogoutMsg
    const type = state?.type
    const data: LogoutMsg = { type: LOGIN_TYPE.EXPIRED};
    const userId = StorageUtil.getLocalStorage(USER_ID)

    const initAuthentication = () => {

        if(type === LOGIN_TYPE.EXPIRED){
            navigate({pathname: '/login', search: createSearchParams(data).toString()})
        }else if(StringUtil.isEmpty(StorageUtil.getLocalStorage(USER_ID))
            || StringUtil.isEmpty(StorageUtil.getLocalStorage(TEAM_ID))
            || StringUtil.isEmpty(StorageUtil.getLocalStorage(ACCESS_TOKEN))
        ) {
            goLogin()
            //goMain()
        }else{
            getUser()   // token 유효성 검사를 위해서 호출
        }
    }

    const {refetch: getUser} = useQuery<SvcUser, AxiosError>(
        ['getUser'],
        ()=> UserService.getUser(userId),
        {
            onSuccess: () => onSuccess(),
            onError: () => onError()
        }
    )

    const onSuccess = () => {
        goMain()
    }

    const onError = () => {
        //goLogin()
        goMain()
    }

    const goMain = () => {
        navigate('/main')
    }

    const goLogin = () => {
        navigate('/login')
    }

    useEffect(()=> {
        setTimeout(function() { // Code here
            initAuthentication()
        }, 1500);
    },[])

    return(
        <>
            <Splash/>
        </>
    )
}



export default AuthenticationView